// extracted by mini-css-extract-plugin
module.exports = {"price":"IR","onSale":"JR"};